import { gql } from '@apollo/client';
import { AccountFragment } from 'shared/domains/users/utils/fragments';
export const setupCompanyMutation = gql `
  mutation CreateAdditionalCompany(
    $planId: UUID!
    $companyName: String!
    $companyMarketCode: String!
    $userId: String!
  ) {
    accounts: createCompanyUser(
      objects: {
        role: owner
        user_id: $userId
        company: {
          data: { name: $companyName, market_code: $companyMarketCode, plans: { data: { plan_id: $planId } } }
        }
      }
    ) {
      returning {
        ...AccountFragment @unmask
      }
    }
  }
  ${AccountFragment}
`;
